import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, FlatButton } from 'material-ui'

import ApptTypesCard from './ApptTypesCard'
import styles from './styles.css'

export default function ConfirmationPopOver(props) {
  const {
    confirmPopOverType,
    confirmPopOverType: {
      id,
      post_nv_window: window,
    },
    closePopOver,
    updateAppointmentType,
  } = props

  return (
    <Dialog
      open={!!id}
      onRequestClose={closePopOver}
      contentStyle={{ width: '500px' }}
      zDepth={10}
    >
      <div className={styles.popOverContainer}>
        <h2>Are you sure you want to make this appointment type available for new patients?</h2>
        <ApptTypesCard
          appointmentType={confirmPopOverType}
        />
        <div className={styles.popOverButton}>
          <FlatButton
            label="Confirm"
            primary
            onClick={() => updateAppointmentType('new', id, window)}
          />
          <FlatButton
            label="Cancel"
            secondary
            onClick={closePopOver}
          />
        </div>
      </div>
    </Dialog>
  )
}

ConfirmationPopOver.propTypes = {
  confirmPopOverType: PropTypes.shape({
    id: PropTypes.string,
  }),
  closePopOver: PropTypes.func.isRequired,
  updateAppointmentType: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/AppointmentTypes/ConfirmationPopOver.js